import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";

export default function CTASection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = sectionRef.current?.querySelectorAll(".reveal");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-dark-bg py-24 md:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Text Content */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h2 className="reveal opacity-0 translate-y-4 transition-all duration-600 ease-out font-serif text-3xl md:text-4xl lg:text-[3.25rem] font-semibold text-charcoal-50 leading-tight mb-6">
            Ready to transform your water?
          </h2>
          <p className="reveal opacity-0 translate-y-4 transition-all duration-600 ease-out delay-150 text-base md:text-lg text-charcoal-300 font-sans leading-relaxed mb-8">
            Schedule a complimentary water quality assessment and receive a
            personalized recommendation for your home. No obligation, just
            expert guidance.
          </p>
          <div className="reveal opacity-0 translate-y-4 transition-all duration-600 ease-out delay-200">
            <Link
              to="/contact"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gold text-dark-bg text-base font-sans font-semibold rounded-full hover:bg-gold-light transition-colors duration-300 group whitespace-nowrap"
            >
              Request a Free Assessment
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}